// frontend/src/components/Web3ConnectButton.jsx
import React from "react";
import { useWeb3 } from "../hooks/useWeb3";

/**
 * Bouton de connexion Web3 (MetaMask / Hardhat)
 * Affiche l'état du wallet et permet la connexion/déconnexion
 */
export default function Web3ConnectButton() {
  const {
    address,
    balance,
    isConnected,
    isLoading,
    connectWallet,
    disconnectWallet,
    refreshBalance,
    network,
    error,
  } = useWeb3();

  const shortAddress = address
    ? `${address.slice(0, 6)}...${address.slice(-4)}`
    : null;

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div className="bg-gray-900 text-white p-4 rounded-2xl shadow-lg w-72 text-center">
        {isLoading ? (
          <p className="text-sm text-gray-400 animate-pulse">Connexion en cours...</p>
        ) : isConnected ? (
          <>
            <p className="text-green-400 font-semibold mb-2">
              ✅ Connecté au réseau {network?.name || "inconnu"}
            </p>
            <p className="text-sm break-all">{shortAddress}</p>
            <p className="text-xs text-gray-400 mt-1">
              {balance ? `${Number(balance).toFixed(4)} ETH` : "--"}
            </p>
            <div className="flex justify-center mt-3 space-x-3">
              <button
                onClick={refreshBalance}
                className="bg-blue-600 hover:bg-blue-500 text-white px-3 py-1 rounded-md text-sm"
              >
                🔄 Rafraîchir
              </button>
              <button
                onClick={disconnectWallet}
                className="bg-red-600 hover:bg-red-500 text-white px-3 py-1 rounded-md text-sm"
              >
                ❌ Déconnecter
              </button>
            </div>
          </>
        ) : (
          <>
            <p className="text-gray-300 mb-3 text-sm">
              Connectez votre wallet pour interagir avec la blockchain.
            </p>
            <button
              onClick={connectWallet}
              className="bg-green-600 hover:bg-green-500 text-white px-4 py-2 rounded-md font-semibold"
            >
              🔗 Connecter MetaMask
            </button>
            {error && (
              <p className="text-red-400 text-xs mt-2">Erreur : {error}</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
